import type { ReactNode } from "react";
import { Group, Stack, Text, ThemeIcon } from "@/components/ui";

interface Props {
  selected: boolean;
  onClick: () => void;
  icon: ReactNode;
  title: string;
  description: string;
  meta: string;
}

/**
 * Card-radio para elegir el subtipo de solicitud · presentacional.
 * El padre maneja la selección · este componente solo refleja el flag
 * y dispara `onClick`. El "radio" es un dot puramente visual (no el átomo
 * `Radio` de Etapa 2 · ese exige un `RadioGroup` padre de Radix y acá no
 * hay grupo real, cada card es un botón independiente con su propio
 * `onClick`, igual que el original Mantine con `onChange={() => {}}`).
 */
export function SubtipoCard({ selected, onClick, icon, title, description, meta }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-[10px] border p-3.5 text-left transition-colors duration-120"
      style={{
        borderColor: selected ? "var(--color-multiva-500)" : "var(--color-border)",
        backgroundColor: selected ? "color-mix(in srgb, var(--color-multiva-600) 8%, transparent)" : "var(--color-background)",
      }}
    >
      <Group gap="md" align="flex-start" wrap="nowrap">
        <span
          aria-hidden="true"
          className="mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full border"
          style={{ borderColor: selected ? "var(--color-multiva-600)" : "var(--color-input)" }}
        >
          {selected && <span className="size-2 rounded-full bg-multiva-600" />}
        </span>
        <ThemeIcon variant={selected ? "filled" : "light"} color="multiva" size="md">
          {icon}
        </ThemeIcon>
        <Stack gap={2} className="min-w-0 flex-1">
          <Group justify="space-between" wrap="nowrap">
            <Text fw={600} size="sm">
              {title}
            </Text>
            <Text size="xs" c="dimmed">
              {meta}
            </Text>
          </Group>
          <Text size="xs" c="dimmed" className="leading-relaxed">
            {description}
          </Text>
        </Stack>
      </Group>
    </button>
  );
}
